'use client';

import type { ContentStaticPagesSingleType } from './data';

import parse from 'html-react-parser';

import { Box, Button, Container, PublicPageHeading, Stack } from '@/components';
import {
  useProfile,
  useSaveUrlFile,
  useStaticPagesPdf,
  useTranslation,
} from '@/hooks';
import { fonts } from '@/theme';

const ContentStaticPagesSingle: ContentStaticPagesSingleType = ({
  title,
  content,
  pageType,
}) => {
  const { t } = useTranslation('pages.staticPage');
  const { isLoading: isDownloading } = useSaveUrlFile();
  const { data: profile } = useProfile();

  const { refetch, isFetching } = useStaticPagesPdf(
    {
      type: pageType,
    },
    false
  );

  const handlePrintPdf = async () => {
    if (isFetching || isDownloading) {
      return;
    }

    await refetch();
  };

  return (
    <>
      <PublicPageHeading title={title} />
      <Container mb={{ base: 5, md: 10 }}>
        <Stack align="center" maxW="full">
          {profile?.user_type === 'agent' && (
            <Stack direction="row" w="full" justify="flex-end">
              <Button
                onClick={() => {
                  void handlePrintPdf();
                }}
                isLoading={isFetching || isDownloading}
                loadingText={t('preparing')}
                variant="outline"
              >
                {t('downloadContract')}
              </Button>
            </Stack>
          )}
          <Box
            maxW={{ base: '100%', md: '5xl' }}
            sx={{
              '*': { fontFamily: `${fonts.style.fontFamily} !important` },
              '& table': { maxWidth: '100%' },
            }}
          >
            {parse(content)}
          </Box>
        </Stack>
      </Container>
    </>
  );
};
export default ContentStaticPagesSingle;
